import { useState, useCallback } from "react";
import axios from "../../../../Axios";
import { Urls } from "../../../../Urls";

/**
 * Fetches the clarification thread for an enquiry and reports how many
 * messages are unread by the current user (messages sent by someone else
 * that are not yet marked is_read). Optionally scoped to a single
 * transporter via forTransporterId.
 */
export const useClarificationUnread = ({
  enquiryId,
  forTransporterId = null,
  currentUserEmail,
  enabled = true,
  initialUnreadCount = 0,
}) => {
  const [unreadCount, setUnreadCount] = useState(initialUnreadCount);

  const refresh = useCallback(() => {
    if (!enabled || !enquiryId || !currentUserEmail) return;

    axios
      .get(`${Urls.spot}?field=get_clarification&enquiry_id=${enquiryId}`)
      .then((res) => {
        const messages = Array.isArray(res.data) ? res.data : [];
        const scoped = forTransporterId
          ? messages.filter((m) => m.for_transporter_id === forTransporterId)
          : messages;
        const unread = scoped.filter(
          (m) => m.email !== currentUserEmail && !m.is_read
        );
        setUnreadCount(unread.length);
      })
      .catch(() => {});
  }, [enquiryId, forTransporterId, currentUserEmail, enabled]);

  return { unreadCount, refresh };
};
